'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.stepStates = {
            INTERACTIVE: 'interactive',
            PASSED: 'passed',
            FUTURE: 'future',
            HIDDEN: 'hidden'
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.contentRef && nextProps.state !== this.props.state) {
                if (nextProps.state === this.stepStates.PASSED && typeof this.contentRef.uiPassed === 'function') {
                    this.contentRef.uiPassed();
                }

                if (nextProps.state === this.stepStates.HIDDEN && typeof this.contentRef.uiHidden === 'function') {
                    this.contentRef.uiHidden();
                }

                if (nextProps.state === this.stepStates.INTERACTIVE && typeof this.contentRef.uiInteractive === 'function') {
                    this.contentRef.uiInteractive();
                }
            }

            return this;
        }
    }, {
        key: 'render',
        value: function render() {
            if (
            // не рисуем будущие шаги, и шаги которые стартовали с PASSED
            // контроллер мог стартовать не с первого шага
            this.props.state === this.stepStates.FUTURE || !this.contentRef && (this.props.state === this.stepStates.PASSED || this.props.state === this.stepStates.HIDDEN)) {
                return null;
            } else if (this.props.state === this.stepStates.INTERACTIVE || this.contentRef && (this.props.state === this.stepStates.PASSED || this.props.state === this.stepStates.HIDDEN)) {
                var component = _react2.default.Children.only(this.props.children);

                return _react2.default.cloneElement(component, Object.assign({}, component.props, {
                    ref: this._stepRef.bind(this),
                    isActiveStep: this.props.state === this.stepStates.INTERACTIVE,
                    toNextStep: this.props.toNextStep,
                    toPrevStep: this.props.toPrevStep,
                    toStep: this.props.toStep,
                    getModel: this.props.getModel,
                    getActiveStep: this.props.getActiveStep
                }));
            }
        }
    }, {
        key: '_stepRef',
        value: function _stepRef(el) {
            if (typeof this.props.stepRefProvider === 'function') {
                this.props.stepRefProvider(el);
            }

            this.contentRef = el;
        }
    }]);

    return _class;
}(_react2.default.Component);

_class.propTypes = {
    stepRefProvider: _propTypes2.default.func,
    getActiveStep: _propTypes2.default.func,
    toNextStep: _propTypes2.default.func,
    toPrevStep: _propTypes2.default.func,
    toStep: _propTypes2.default.func,
    getModel: _propTypes2.default.func,
    children: _propTypes2.default.element,
    state: _propTypes2.default.oneOf(['interactive', 'passed', 'future', 'hidden'])
};
_class.displayName = 'Base.Views.Step';
exports.default = _class;